/**
 * 🎭 v7.56 (per Javi): the face-off scenes before each act and each boss fight
 * can be switched off in the menu ("Story scenes"). On by default; a device
 * preference like the mutes and Tap to Fast Forward (a wipe keeps it -
 * progressEpoch PRESERVED_KEYS). The browser suites seed it '0' so the
 * dialogue stays out of their way; tests/versus-ui.mjs seeds it '1'.
 */
export const STORY_SCENES_KEY = 'elemental-dispatch-story-scenes-v1'

type Store = Pick<Storage, 'getItem'> | null | undefined

/** Unset or anything but '0' means on. */
export function readStoryScenes(store: Store): boolean {
  try { return store?.getItem(STORY_SCENES_KEY) !== '0' } catch { return true }
}

export function useStoryScenes() {
  const on = useState<boolean>('story-scenes', () => {
    try { return readStoryScenes(localStorage) } catch { return true }
  })
  const enabled = computed(() => on.value)
  function setEnabled(value: boolean) {
    on.value = value
    try { localStorage.setItem(STORY_SCENES_KEY, value ? '1' : '0') } catch { /* this session only */ }
  }
  return { enabled, setEnabled }
}
